import './PageFooter.scss';
import { Translate } from 'react-redux-i18n';
import useCountryCodeInfo from '@helpers/customHooks/useCountryCodeInfo';

const PageFooter = () : JSX.Element => {
    const { featuresList } = useCountryCodeInfo();
    const { termsOfUseURL, privacyPolicyURL } = featuresList;
    const currentYear = new Date().getFullYear();
    return (
        <div className="footer">
            <div className="footer-copy-rights-content">
                <Translate value="dashboard-footer" currentYear={currentYear} />
            </div>
            <div className="footer-link-content">
                <a className="footer-link-content-privacy-policy" href={privacyPolicyURL} rel="noopener noreferrer" target="_blank">
                    <Translate value="privacy-policy" />
                </a>
                <a className="footer-link-content-terms-of-use" href={termsOfUseURL} rel="noopener noreferrer" target="_blank">
                    <Translate value="terms-of-use" />
                </a>
            </div>
        </div>
    );
};

export default PageFooter;
